import Icon from 'components/shared/Icon/Icon';

const Header = ({ icon, date, title, open }) => {
  return (
    <div className="flex w-full justify-between px-2">
      <div className="flex items-center">
        <Icon icon={icon ?? 'responsibility-1'} />
        <p className="ml-2 text-neutral-900">{title}</p>
      </div>
      <div className="flex items-center">
        <div className="text-neutral-800">
          Due date:{' '}
          <span
            className={`ml-1 text-sm  ${
              date === 'Not set'
                ? 'text-neutral-500'
                : 'rounded-2xl border border-solid border-black border-opacity-[12%] bg-neutral-200 px-2.5 py-1 font-500 text-neutral-700'
            }`}>
            {date}
          </span>
        </div>
        <Icon
          className={`Icon--neutral-700 ml-3 transform transition-transform ${open ? '' : 'rotate-180'}`}
          size={20}
          icon="chevron-up-linear"
        />
      </div>
    </div>
  );
};

export default Header;
